// Screen 6: call ended (route /thanks-call).
import { useEffect } from 'react'
import BrandLockup from '../components/BrandLockup'
import { useLocation } from 'react-router-dom'
import { convertTimerFormat } from '../core/callStatus'
import { t } from '../i18n'

const CallEnded = () => {
  const { state } = useLocation() as any
  const duration = state?.duration

  // DON'T ALLOW NAVIGATING BACK INTO THE FINISHED CALL.
  useEffect(() => {
    window.history.pushState(null, '', null)
    window.onpopstate = function () {
      window.history.go(1)
    }
    return () => {
      window.onpopstate = null
    }
  }, [])

  const callAgain = () => {
    const scanUrl = sessionStorage.getItem('cf_scan_url')
    if (scanUrl) {
      window.location.hash = scanUrl.startsWith('#') ? scanUrl.slice(1) : scanUrl
    }
  }

  return (
    <div className="cf-page">
      <div className="cf-card">
        <BrandLockup />
        <div className="cf-icon">✅</div>
        <h1 className="cf-title">{t.callEndedTitle}</h1>
        {duration > 0 && <p className="cf-duration">{t.callDuration(convertTimerFormat(duration))}</p>}
        <p className="cf-subtitle">{t.thanksForUsing}</p>
        {sessionStorage.getItem('cf_scan_url') && (
          <>
            <p className="cf-subtitle">{t.needAnythingElse}</p>
            <button className="cf-btn cf-btn-primary" onClick={callAgain}>
              {t.callAgain}
            </button>
          </>
        )}
        <p className="cf-note">{t.youMayCloseScreen}</p>
      </div>
    </div>
  )
}

export default CallEnded
